import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const StartWorkflowButtonWidget: WidgetRegistryEntry = {
  name: "StartWorkflowButton",
  configuration: () => import("./configuration").then((m) => m.StartWorkflowButtonWidgetConfiguration),
  component: () => import("./start-workflow-button-widget.component").then((m) => m.StartWorkflowButtonWidgetComponent)
};
